import camelCase from "lodash/camelCase";
import { EntriesTableSettings } from "../../../model/entries-table-settings/EntriesTableSettings";
import { t } from "i18next";

export const getTranslatedTableColumnLabel = (
  column: EntriesTableSettings["columns"][number],
) => {
  return column?.custom ? column.label : t(`common.${camelCase(column.field)}`);
};
